import React from 'react'

import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { ConfigurableTable } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config/context'
import { useOrder } from '../../data'

interface Props {
  id: string
}

export const TermsOfPayment: React.FC<Props> = ({ id }) => {
  const { data: order, isLoading } = useOrder(id)
  const { uiConfig: config } = useConfigContext()

  return (
    <>
      {config.orderResponse.orderInformation.termsOfPayment.enabled !==
        false && (
        <>
          <h3 className="mt-6">
            {getConfigTranslation(
              config.orderResponse.orderInformation.termsOfPayment.title,
            )}
          </h3>
          <ConfigurableTable
            config={config.orderResponse.orderInformation.termsOfPayment.table}
            data={order?.Payload?.TermsOfPayment}
            isLoading={isLoading}
            stateKey=""
          />
        </>
      )}
    </>
  )
}
